<div class="row mb-4" [hidden]="field.hidden" [formGroup]="formGroup!">

    <label class="col-sm-2 col-form-label form-label">
        {{field.label}}
        <span class="text-danger" *ngIf="field.required"> * </span>
    </label>

    <div class="col-sm-10">

        
        <!-- <p-calendar formControlName="{{fieldId}}" [(ngModel)]="date" dateFormat="dd/mm/yy"   [ngClass]="isInvalid && submitted ? 'ng-invalid ng-dirty':null"   [required]="field.required && !field.hidden!" (onSelect)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)"  /> -->

        <input class="form-control" [(ngModel)]="date" [readOnly]="!field.editable && field.editable!=null"  [min]="minDate" [max]="maxDate"  [ngClass]="isInvalid && submitted ? 'is-invalid':null"  formControlName="{{fieldId}}" type="date" [required]="field.required && !field.hidden!" (blur)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)">
        
        <p class="pt-1" style="font-size: 13px !important;" *ngIf="field?.description">
            {{field.description}}
        </p>

        <p class="pt-1 text-danger" style="font-size: 13px !important;" *ngIf="yourTurn && field?.approved == false">
            {{field.comment}}
        </p>

        <div *ngIf="isInvalid && submitted">
            <span class="text-danger"
                *ngIf="errors?.['required']">
                {{'requiredField'|translate}}!
            </span>
        </div>
    </div>
</div>